import { render, staticRenderFns } from "./EditFacilityModal.vue?vue&type=template&id=1308c837&scoped=true&"
import script from "./EditFacilityModal.vue?vue&type=script&lang=js&"
export * from "./EditFacilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1308c837",
  null
  
)

export default component.exports